import apiClient from '@/services/api_client_saas.js'

export const state = {
  models: []
}

export const mutations = {
  SET_MODELS (state, value) {
    state.models = value
  }
}

export const getters = {
  transcribeModels: state => {
    return state.models.sort((a, b) => a.description.localeCompare(b.description)).map(x => { return { name: x.name, label: x.description } })
  }
}

export const actions = {
  loadModels ({ state, commit, rootState }) {
    if (!state.models.length) {
      return apiClient
        .get('/transcribe/models')
        .then(response => {
          this.commit('SET_MODELS', response.data)
        })
        .catch(err => {
          console.log(`Unable to retrieve data: ${err}`)
          return Promise.reject(err)
        })
    } else {
    }
  }
}
